<template>
  <div class="pagination">
    <div class="paginate_button hoverable mr-1 clickable" @click="goPrev">
      Sebelum
    </div>
    <div class="paginate_button hoverable clickable mr-1" v-for="(pageNumber, index) in loadPagination()" :key="index"
      :class="[{ active: pageNumber === page }]" @click="goTo(pageNumber)">
      {{ pageNumber }}
    </div>
    <div class="paginate_button hoverable clickable" @click="goNext">
      Lanjut
    </div>
    <!-- <div class="input-group" v-if="goto" style="border: none !important">
      <input
        type="number"
        min="1"
        :max="total_page"
        step="1"
        v-model="page_goto"
        class="bg-transparent text-dark ml-1"
        style="
          max-width: 50px;
          height: 1.8rem !important;
          border: solid rgba(184, 192, 202, 0.5) 1px !important;
          border-radius: 5px 0 0 5px !important;
        "
      />
      <div
        class="input-group-append"
        style="border-radius: 0 6px 6px 0 !important; height: 1.8rem !important"
      >
        <button
          type="button"
          class="btn"
          @click="goTo(page_goto)"
          style="
            background-color: #f16528;
            color: white;
            border-radius: 0 5px 5px 0 !important;
            border: solid rgba(184, 192, 202, 0.5) 1px !important;
          "
        >
          Go
        </button>
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  name: "pagination",
  props: {
    data: Object,
    goto: {
      type: Boolean,
      default: function () {
        return false;
      },
    },
  },
  data() {
    return {
      total: this.data ? this.data.total : null,
      limit: this.data ? this.data.limit : null,
      page: this.data ? this.data.page : null,
      total_page: 0,
      page_goto: this.$route.query.page ? this.$route.query.page : 1,
    };
  },
  methods: {
    loadPagination: function () {
      var total_page = Math.ceil(this.total / this.limit);
      this.total_page = total_page;

      if (typeof this.$parent.total_page !== "undefined") {
        this.$parent.total_page = this.total_page;
      }

      var paging = [];
      var i;
      if (total_page > 5) {
        if (this.page < 5) {
          for (i = 1; i <= 5; i++) {
            paging.push(i);
          }
        } else {
          var last_page = this.page + 1;
          if (last_page > total_page) {
            last_page = total_page;
          }
          if (this.page - 3 > 1) {
            paging.push(1);
            paging.push("..");
          }
          for (i = this.page - 1; i <= last_page; i++) {
            paging.push(i);
          }
        }

        if (
          (last_page <= this.total_page - 2 || this.page <= 5) &&
          this.total_page > 6
        ) {
          paging.push("..");
        } else {
          if (last_page + 2 < this.total_page) {
            paging.push(last_page + 1);
          }
        }

        if (this.page < total_page - 1) {
          paging.push(total_page);
        }
      } else {
        for (i = 1; i <= total_page; i++) {
          paging.push(i);
        }
      }

      return paging;
    },
    goTo: function (pageNumber) {
      if (
        this.$route.query.page != pageNumber &&
        pageNumber != ".." &&
        pageNumber <= this.total_page &&
        pageNumber % 1 == 0
      ) {
        this.updateUrlQuery("page", pageNumber);
      }
    },
    goNext: function () {
      var current_page = this.$route.query.page;
      if (!current_page) {
        current_page = 1;
      }
      current_page = parseInt(current_page);
      if (current_page > 0 && current_page < this.total_page) {
        this.updateUrlQuery("page", current_page + 1);
      }
    },
    goPrev: function () {
      var current_page = this.$route.query.page;
      if (current_page > 1 && current_page <= this.total_page) {
        this.updateUrlQuery("page", current_page - 1);
      }
    },
    updateUrlQuery: function (key, value) {
      let queries = JSON.parse(JSON.stringify(this.$route.query));
      queries[key] = value;
      this.$router.replace({ query: queries });
      this.$emit("pageChange");
    },
  },
};
</script>

<style scoped>
.active {
  background: #f16528 !important;
  color: #fff !important;
}

/* .pagination button {
  max-width: 50px;
} */
.pagination button:hover {
  background: #f16528 !important;
  color: #fff !important;
}
</style>
